import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  LeanIXAppIdField,
  LeanIXAppIdExtensionSchema,
  validateLeanIXAppId,
} from './LeanIXAppId';

export const LeanIXAppIdFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'LeanIXAppId_ConditionalField',
    component: LeanIXAppIdField,
    validation: validateLeanIXAppId,
    schema: LeanIXAppIdExtensionSchema,
  }),
);
